import axios from "axios";
const BASE = "https://znsnu3lpc1.execute-api.ap-south-1.amazonaws.com";

export const uvToday = () => axios.get(`${BASE}/dashboard/uv-today`);
export const uvYesterday = () => axios.get(`${BASE}/dashboard/uv-yesterday`);
export const uvLast7 = () => axios.get(`${BASE}/dashboard/uv-last7days`);
export const uvLast30 = () => axios.get(`${BASE}/dashboard/uv-last30days`);

export const uvMonthlyRange = (body) =>
  axios.post(`${BASE}/dashboard/uv-range-monthly`, body);
